import {CallForPapers, FormWidget, PaperSubmission} from "../../../types/types";

/**
 * Widget Ausstellernummer aus Rubin (RegiNr)
 * Der Wert, wird falls Query Parameter vorbelegt ist, aus der URL per Query Parameter vorbelegt
 */
interface OrganizerRegiNumberWidget extends FormWidget {
    prefillQueryParam: string|null
}

export function type() {
    return 'organizer_regi_number';
}

/**
 * liest den Wert aus der Paper Submission aus und gibt ihn zurück
 * @param callForPapers
 * @param widget
 * @param submission
 * @returns {*}
 */
export function submissionValue(callForPapers: CallForPapers, widget: FormWidget, submission: PaperSubmission) {
    return submission?.pcoPlus?.organizerRegiNumber
}

/**
 * Falls der initiale Wert des Widgets in der URL gesetzt ist, wird dieser Wert für das Widget genommen
 *
 * @param widget
 * @param urlParams
 */
export function initialValue(widget: OrganizerRegiNumberWidget, urlParams: URLSearchParams) {
    if (widget.prefillQueryParam !== null && urlParams.has(widget.prefillQueryParam)) {
        const regiNumber: string|null = urlParams.get(widget.prefillQueryParam)
        if(regiNumber !== null && (/^\d+$/).test(regiNumber)) {
            return parseInt(regiNumber)
        }
    }
    return null;
}

export {schema, component} from '../IntegerInputWidget'